<template>
	<div class="detrusion">
		<div class="title">患者入组为</div>
		<div class="detrusion-main">
			<div class="dtree-select">
				<a-tree-select
          :getPopupContainer="triggerNode => triggerNode.parentNode"
          style="width: 100%"
          :value="value"
          :dropdownStyle="{ maxHeight: '300px', overflow: 'auto' }"
          placeholder="请选择组"
          showSearch
          allowClear
          treeDefaultExpandAll
          @change="onChange"
				>
					<a-tree-select-node
            v-for="(item) in treeData"
            :value="item.groupName"
            :title="item.groupName"
            :key="item.id"
					>
					</a-tree-select-node>
				</a-tree-select>
			</div>
			<a-button type="primary" class="confirm-primary" @click="submitGoGrouping()">确定</a-button>
		</div>
	</div>
</template>

<script>
  export default {
    data() {
      return {
        treeExpandedKeys: [],
        value: undefined,
        valueId: undefined,
        total: "",
        treeData: [],
        ids: [],
        timeOut: null
      };
    },
    props: {
      dataList: {type: Array, default: []}
    },
    methods: {
      onChange(value, label, extra) {
        this.value = value;
        this.valueId = value ? extra.triggerNode.eventKey : '';
      },
      //患者入组
      submitGoGrouping() {
        let _this = this;
        let data = {};
        if (this.value) {
          this.ids = [];
          this.dataList.map(item => {
            this.ids.push(item.id);
          });
          data = {operationCode: 1, patientGroupId: this.valueId, ids: this.ids};
          this.$get("patient/inOrOutGroup", data).then(res => {
            if (res.data.code == 1) {
              this.$message.success("操作成功");
              this.$emit('close');
              this.$emit('getData');
            } else {
              this.$message.error(res.data.message);
            }
          }).catch(err => {
          });
        } else {
          this.$message.error("请选择要入的组");
        }
      },
      // 查找组列表
      // GET /api/patientgroup
      findGroupList() {
        this.$get("patientgroup?status=1").then(res => {
          this.treeData = res.data.data;
        });
      }
    },
    created() {
      this.findGroupList();
    }
  };
</script>

<style lang="scss" scoped>
	.detrusion {
		.title {
			padding: 82px 0 56px 0;
			font-size: 26px;
			font-family: PingFang SC;
			font-weight: 400;
			color: rgba(51, 51, 51, 1);
		}
		.detrusion-main {
			width: 510px;
			margin: 0 auto;
		}

		.dtree-select {
			height: 350px;
		}
	}
</style>